import { connect } from "react-redux";
import AccountsCollection from "../../accountsview/AccountsCollection";
import {fetchUserAccountsAction} from "../apicalls/FetchUserAccounts";

const mapStateToProps = (state, ownProps) => {
    const  { accounts, accountsLoading, accountsError, userIsLoading } = state;
    const  { csrfToken } = ownProps;
    return { accounts, accountsLoading, accountsError, userIsLoading,  csrfToken }
};

const mapDispatchToProps = dispatch => {
    return {
        fireGetUserAccountsAction: () => {
            dispatch(fetchUserAccountsAction())
        }
    }
};

export const AccountsCollectionAdapter = connect(mapStateToProps, mapDispatchToProps)(AccountsCollection);